import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";
import { useIntercom } from 'react-use-intercom';
import { useFirestore } from "react-redux-firebase";

import Button from '@/components/Button'
import { ModalContext } from '../contexts/ModalContext'
import { getFunctions, httpsCallable } from "firebase/functions";
import errorToast from '@/utils/errorToast'

export default function LinkAccount() {
  const [serverErrors, setServerErrors] = useState(false)
  const { closeModal } = useContext(ModalContext)
  const { showNewMessages } = useIntercom();
  const functions = getFunctions();
  const createOrder = httpsCallable(functions, 'createOrder');

  const handleRequest = () => {
    closeModal()
    showNewMessages('I would like to use a staking account.')
  }

  const schema = yup.object().shape({
    rsn: yup.string().required().min(1).max(12)
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmitHandler = async data => {
    try {
      const order = await createOrder({
        ...data,
        type: 'Account'
      })
      showNewMessages(`I would like to link my own account (${data.rsn}) Here is my order ${order.data}`)
      closeModal()
    } catch (error) {
      errorToast(error)
      setServerErrors(error.message)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="grid gap-4">
      <p className="text-gray-300 text-xs">
        We offer maxed out staking accounts to any user with a balance exceeding <span className="font-bold">250m</span>.
        If you require an account, please request one below.
      </p>
      <div>
        <label className="mb-1 font-medium block">Runescape Name</label>
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-2">
            <input {...register('rsn')} type="text" className={errors.rsn ? '!border-red-500' : ''} />
          </div>
          <Button type="submit" className="py-2.5">
            {isSubmitting ? (
              <span className="flex items-center justify-center">
                Processing
                <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            ) : (
              <span>Link</span>
            )}
          </Button>
        </div>
        {serverErrors && <p className="text-xs text-red-500 font-medium mt-2">{serverErrors}</p>}
      </div>
      <div className="flex items-center">
        <div className="border-b border-gray-700 flex-1"></div>
        <span className="block mx-2 text-gray-300">Or</span>
        <div className="border-b border-gray-700 flex-1"></div>
      </div>
      <div>
        <Button onClick={handleRequest} modifier="secondary" className="py-2.5 w-full">Request an account</Button>
      </div>
    </form>
  )
}
